<template>
    <div>
        <Row type="flex" justify="space-between"  align="middle" class="code-row-bg">
            <Col span="2" v-if="invoiceDue.markingHeaderCode">
                {{  invoiceDue.markingHeaderCode }}
            </Col>
            <Col span="2">
                {{  invoiceDue.invoicedate | showDateFormatted }}
            </Col>
            <Col span="4">
                {{ invoiceDue.description }}
            </Col>

            <Col
                span="2" align="right" >
                {{ invoiceDue.invoicefee | currency }}
            </Col>
            <Col span="1" >
                <Tooltip
                  v-show="invoiceDue.receivableDebitAmount != invoiceDue.invoicefee"
                  placement="top">

                <Icon type="ios-help-outline"></Icon>
                    <div slot="content">
                        <template>
                            Invoice Awal : {{ invoiceDue.receivableDebitAmount | currency}}
                        </template>
                    </div>
                </Tooltip>
            </Col>

            <template v-if="invoiceDue.invoicefee == invoiceDue.receivableRemaining">
                <Col
                    span="2" align="right" >
                    {{ invoiceDue.receivableRemaining | currency}}
                </Col>

            </template>
            <template v-else>
                <Col
                    span="2" align="right" style="color: red;">
                    {{ invoiceDue.receivableRemaining | currency}}
                </Col>
            </template>
            <Col span="1" >
                <Tooltip
                  v-show="invoiceDue.receivableRemaining != invoiceDue.invoicefee"
                  placement="top">

                <Icon type="ios-help-outline"></Icon>
                    <div slot="content">
                        <!-- Total Bayar : {{ invoiceDue.receivableRemaining  | currency}} -->
                        Total Bayar : {{ invoiceDue.paymentSum  | currency}}
                    </div>
                </Tooltip>
            </Col>
            <template v-if="paymentClaimId == null">
            <Col span="3" >
               <money v-model="allocateAmount" v-bind="money"
                    class="ivu-input ivu-input-small" >
                    </money>
                    <div v-show="depositRemaining > 0" style="margin-top:10px;">
                        Deposit <money v-model="useDepositAmount" v-bind="money"
                                class="ivu-input ivu-input-small"
                                style="width : 120px">
                            </money>
                    </div>
            </Col>
            </template>
            <template v-if="paymentClaimId">
            <Col span="2" >
               <money v-model="allocateAmount" v-bind="money"
                    class="ivu-input ivu-input-small" >
                    </money>
                    <div v-show="depositRemaining > 0" style="margin-top:10px;">
                        Deposit <money v-model="useDepositAmount" v-bind="money"
                                class="ivu-input ivu-input-small"
                                style="width : 120px">
                            </money>
                    </div>
            </Col>
            </template>
            <Col span="2">
              <div v-if="paymentClaimId">
                  <money v-model="discountAmount" @input="maximalDiscount" v-bind="money"
                    class="ivu-input ivu-input-small" >
                  </money>
              </div>
            </Col>
            <Col span="4">
              <div v-if="paymentClaimId">
                  <Input v-model="discountDescription" style="width: 200px;" placeholder="Keterangan Potongan" ></Input>
              </div>
            </Col>
            <Col span="1">
                <Button-group size="small" >
                    <Button type="success" @click="toggleAllocateAll()" >All</Button>
                </Button-group>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <br/>
                <hr/>
            </Col>
        </Row>
    </div>
</template>

<script>
import {Money} from 'v-money'
const numeral = require('numeral');
import moment from 'moment'


export default {
    props: {
        invoiceDue : Object,
        depositRemaining: Number,
        paymentClaimId: Number,
        paymentClaimAmount: Number,
    },
    data: () => ({
        allocateAmount : 0,
        useDepositAmount : 0,
        discountAmount : 0,
        discountDescription : '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        }
    }),
    components: {Money},
    methods: {
        toggleAllocateAll: function () {
            let receivableRemaining =
                this.invoiceDue.receivableRemaining - (this.allocateAmount + this.useDepositAmount)

            this.allocateAmount += receivableRemaining;
        },
        emitAllAmount : function(){
            // this.toggleAllocateAll();
            this.$emit('setAllocateAmount', this.invoiceDue)
        },
        distributePayment: function(){
          if(this.invoiceDue.giroAmount > 0) {
            this.allocateAmount = this.invoiceDue.giroAmount;
          }
        },
        maximalDiscount: function(){
          if (this.discountAmount > this.invoiceDue.receivableRemaining) {
              this.discountAmount = this.invoiceDue.receivableRemaining;
            }
          this.$forceUpdate();
        }
    },
    mounted() {
      this.distributePayment();
    },
    watch: {
        allocateAmount: function (newAllocateAmount) {
            this.invoiceDue.allocateAmount = _.parseInt(this.allocateAmount);
            let amount = this.allocateAmount + this.discountAmount;

            if (amount > this.invoiceDue.receivableRemaining) {
              this.discountAmount = 0
            }
            console.log(amount)

            this.emitAllAmount();
        },
        discountAmount: function (newDiscountAmount) {
            this.invoiceDue.discountAmount = _.parseInt(this.discountAmount);
            let amount = this.allocateAmount + this.discountAmount;

            if (amount > this.invoiceDue.receivableRemaining) {
              this.allocateAmount = (this.allocateAmount - this.discountAmount) + ( this.invoiceDue.receivableRemaining - this.allocateAmount)
            }
            this.emitAllAmount();
        },
        discountDescription: function () {
            this.invoiceDue.discountDescription = this.discountDescription;
            this.emitAllAmount();
        },
        useDepositAmount: function () {
            this.invoiceDue.useDepositAmount = _.parseInt(this.useDepositAmount);
            this.emitAllAmount();
        },
    },

  filters: {
    currency: function (value) {
      if (!value) return ''
      return numeral(value).format('0,0')
    },
    showDateFormatted : function(stringToFormat){
        let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
        return moment(dateToFormat).format("DD MMM YYYY")
    }
  }
}

</script>
<style>
  .ivu-input {
    /* height: 24px; */
  }
</style>



// WEBPACK FOOTER //
// cInvoicePayment.vue?ea1099ea